export default [{
        id: 1,
        path: "help",
        title: "ช่วยเหลือ",
        type: 1,
        form: [{
            coverImage: "",
            title: "",
            options: []
        }],
    },
    {
        id: 2,
        path: "helpOnlineService",
        title: "บริการออนไลน์",
        type: 1,
        form: [{
            coverImage: "",
            title: "",
            options: []
        }],
    },
    {
        id: 8,
        path: "helpQuestion",
        title: "คำถามที่พบบ่อย",
        type: 1,
        form: [{
            coverImage: "",
            title: "",
            options: []
        }],
    },
    {
        id: 4,
        path: "helpCannotGetOTP",
        title: "รหัสผ่านใช้ครั้งเดียว (OTP)",
        type: 1,
        form: [{
            coverImage: "",
            title: "",
            options: []
        }],
    },
    {
        id: 3,
        path: "cannotRegister",
        title: "สมัครใช้บริการไม่ได้",
        type: 2,
        form: [{
            title: ""
        }],
    },
    {
        id: 9,
        path: "questionReceipt",
        title: "ใบเสร็จรับเงิน",
        type: 2,
        form: [{
            title: ""
        }],
    },
    {
        id: 13,
        path: "questionTax",
        title: "การต่อภาษี / พ.ร.บ.",
        type: 2,
        form: [{
            title: ""
        }],
    },
    {
        id: 16,
        path: "changeUserData",
        title: "การเปลี่ยนแปลงข้อมูลลูกค้า",
        type: 2,
        form: [{
            title: ""
        }],
    },
    {
        id: 19,
        path: "transferContract",
        title: "การโอนเล่มทะเบียน",
        type: 2,
        form: [{
            title: ""
        }],
    },
    {
        id: 6,
        path: "changePhoneNo",
        title: "เปลี่ยนเบอร์โทรศัพท์",
        type: 2,
        form: [{
            title: ""
        }],
    },
    {
        id: 7,
        path: "OTPAbroad",
        title: "รับรหัสผ่าน (OTP) ต่างประเทศ",
        type: 2,
        form: [{
            title: ""
        }],
    },
    {
        id: 5,
        path: "noOTP",
        title: "ไม่ได้รับรหัสผ่านใช้ครั้งเดียว (OTP)",
        type: 2,
        form: [{
            title: ""
        }],
    },
    {
        id: 36,
        path: "SKLRegister",
        title: "ลงทะเบียน SKL Connect",
        type: 3,
        form: [{
            images: [],
            removeList: []
        }],
    }
]